import _Converter from "./converter/Converter";
import _DomEventEngine from "./dom-event-engine/DomEventEngine";
import _EventEngine from "./event-engine/EventEngine";
import _EventTypes from "./event-engine/EventTypes";
import _HttpClient from "./http-client/HttpClient";
import _InputValidator from "./input-validator/InputValidator";
import _ErrorTypeGuards from "./logger/ErrorTypeGuards";
import _Logger from "./logger/Logger";
import _PerformanceEvaluator from "./performance-evaluator/PerformanceEvaluator";
import _SettingsEngine from "./settings-engine/SettingsEngine";
import _ShapeDiverBackendErrors from "./logger/ShapeDiverBackendErrors";
import * as _sdk2 from "@shapediver/sdk.geometry-api-sdk-v2";
var _sdk = _sdk2;
try {
  if ("default" in _sdk2) _sdk = _sdk2.default;
} catch (e) {}
import _ShapeDiverViewerErrors from "./logger/ShapeDiverViewerErrors";
import _ShapeDiverError from "./logger/ShapeDiverError";
import _StateEngine from "./state-engine/StateEngine";
import _StatePromise from "./state-engine/StatePromise";
import _SystemInfo from "./system-info/SystemInfo";
import _TypeChecker from "./type-check/TypeChecker";
import _UuidGenerator from "./uuid-generator/UuidGenerator";
import _base from "./utilities/base64";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isViewerWebGLError = exports.isViewerEnvironmentMapError = exports.isViewerDataProcessingError = exports.isViewerUnknownError = exports.isViewerError = exports.ShapeDiverGeometryBackendResponseErrorType = exports.ShapeDiverGeometryBackendResponseError = exports.ShapeDiverGeometryBackendRequestError = exports.ShapeDiverGeometryBackendError = exports.ShapeDiverViewerDrawingToolsError = exports.ShapeDiverViewerInteractionError = exports.ShapeDiverViewerValidationError = exports.ShapeDiverViewerCameraError = exports.ShapeDiverViewerLightError = exports.ShapeDiverViewerArError = exports.ShapeDiverViewerUnknownError = exports.ShapeDiverViewerViewportError = exports.ShapeDiverViewerSessionError = exports.ShapeDiverViewerSettingsError = exports.ShapeDiverViewerWebGLError = exports.ShapeDiverViewerEnvironmentMapError = exports.ShapeDiverViewerDataProcessingError = exports.ShapeDiverViewerError = exports.ShapeDiverViewerErrorType = exports.LOGGING_LEVEL = exports.Logger = exports.InputValidator = exports.TypeChecker = exports.Converter = exports.UuidGenerator = exports.HttpClient = exports.DomEventEngine = exports.SystemInfo = exports.StatePromise = exports.StateEngine = exports.SESSION_SETTINGS_MODE = exports.SettingsEngine = exports.EVENTTYPE_TASK = exports.EVENTTYPE_DRAWING_TOOLS = exports.EVENTTYPE_GUMBALL = exports.EVENTTYPE_INTERACTION = exports.EVENTTYPE_VIEWPORT = exports.EVENTTYPE_SESSION = exports.EVENTTYPE_SCENE = exports.EVENTTYPE_RENDERING = exports.EVENTTYPE_PARAMETER = exports.EVENTTYPE_OUTPUT = exports.EVENTTYPE_CAMERA = exports.EVENTTYPE = exports.EventEngine = void 0;
exports.btoaCustom = exports.atobCustom = exports.PerformanceEvaluator = exports.isViewerGeometryBackendResponseError = exports.isViewerGeometryBackendRequestError = exports.isViewerGeometryBackendGenericError = exports.isViewerGeometryBackendError = exports.isViewerDrawingToolsError = exports.isViewerInteractionError = exports.isViewerValidationError = exports.isARError = exports.isViewerCameraError = exports.isViewerLightError = exports.isViewerViewportError = exports.isViewerSessionError = exports.isViewerSettingsError = void 0;
const Converter_1 = _Converter;
Object.defineProperty(exports, "Converter", {
  enumerable: true,
  get: function () {
    return Converter_1.Converter;
  }
});
const DomEventEngine_1 = _DomEventEngine;
Object.defineProperty(exports, "DomEventEngine", {
  enumerable: true,
  get: function () {
    return DomEventEngine_1.DomEventEngine;
  }
});
const EventEngine_1 = _EventEngine;
Object.defineProperty(exports, "EventEngine", {
  enumerable: true,
  get: function () {
    return EventEngine_1.EventEngine;
  }
});
const EventTypes_1 = _EventTypes;
Object.defineProperty(exports, "EVENTTYPE", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE;
  }
});
Object.defineProperty(exports, "EVENTTYPE_CAMERA", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_CAMERA;
  }
});
Object.defineProperty(exports, "EVENTTYPE_DRAWING_TOOLS", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_DRAWING_TOOLS;
  }
});
Object.defineProperty(exports, "EVENTTYPE_GUMBALL", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_GUMBALL;
  }
});
Object.defineProperty(exports, "EVENTTYPE_INTERACTION", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_INTERACTION;
  }
});
Object.defineProperty(exports, "EVENTTYPE_OUTPUT", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_OUTPUT;
  }
});
Object.defineProperty(exports, "EVENTTYPE_PARAMETER", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_PARAMETER;
  }
});
Object.defineProperty(exports, "EVENTTYPE_RENDERING", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_RENDERING;
  }
});
Object.defineProperty(exports, "EVENTTYPE_SCENE", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_SCENE;
  }
});
Object.defineProperty(exports, "EVENTTYPE_SESSION", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_SESSION;
  }
});
Object.defineProperty(exports, "EVENTTYPE_TASK", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_TASK;
  }
});
Object.defineProperty(exports, "EVENTTYPE_VIEWPORT", {
  enumerable: true,
  get: function () {
    return EventTypes_1.EVENTTYPE_VIEWPORT;
  }
});
const HttpClient_1 = _HttpClient;
Object.defineProperty(exports, "HttpClient", {
  enumerable: true,
  get: function () {
    return HttpClient_1.HttpClient;
  }
});
const InputValidator_1 = _InputValidator;
Object.defineProperty(exports, "InputValidator", {
  enumerable: true,
  get: function () {
    return InputValidator_1.InputValidator;
  }
});
const ErrorTypeGuards_1 = _ErrorTypeGuards;
Object.defineProperty(exports, "isARError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isARError;
  }
});
Object.defineProperty(exports, "isViewerCameraError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerCameraError;
  }
});
Object.defineProperty(exports, "isViewerDataProcessingError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerDataProcessingError;
  }
});
Object.defineProperty(exports, "isViewerDrawingToolsError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerDrawingToolsError;
  }
});
Object.defineProperty(exports, "isViewerEnvironmentMapError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerEnvironmentMapError;
  }
});
Object.defineProperty(exports, "isViewerError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerError;
  }
});
Object.defineProperty(exports, "isViewerGeometryBackendError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerGeometryBackendError;
  }
});
Object.defineProperty(exports, "isViewerGeometryBackendGenericError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerGeometryBackendGenericError;
  }
});
Object.defineProperty(exports, "isViewerGeometryBackendRequestError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerGeometryBackendRequestError;
  }
});
Object.defineProperty(exports, "isViewerGeometryBackendResponseError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerGeometryBackendResponseError;
  }
});
Object.defineProperty(exports, "isViewerInteractionError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerInteractionError;
  }
});
Object.defineProperty(exports, "isViewerLightError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerLightError;
  }
});
Object.defineProperty(exports, "isViewerSessionError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerSessionError;
  }
});
Object.defineProperty(exports, "isViewerSettingsError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerSettingsError;
  }
});
Object.defineProperty(exports, "isViewerUnknownError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerUnknownError;
  }
});
Object.defineProperty(exports, "isViewerValidationError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerValidationError;
  }
});
Object.defineProperty(exports, "isViewerViewportError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerViewportError;
  }
});
Object.defineProperty(exports, "isViewerWebGLError", {
  enumerable: true,
  get: function () {
    return ErrorTypeGuards_1.isViewerWebGLError;
  }
});
const Logger_1 = _Logger;
Object.defineProperty(exports, "Logger", {
  enumerable: true,
  get: function () {
    return Logger_1.Logger;
  }
});
Object.defineProperty(exports, "LOGGING_LEVEL", {
  enumerable: true,
  get: function () {
    return Logger_1.LOGGING_LEVEL;
  }
});
const PerformanceEvaluator_1 = _PerformanceEvaluator;
Object.defineProperty(exports, "PerformanceEvaluator", {
  enumerable: true,
  get: function () {
    return PerformanceEvaluator_1.PerformanceEvaluator;
  }
});
const SettingsEngine_1 = _SettingsEngine;
Object.defineProperty(exports, "SESSION_SETTINGS_MODE", {
  enumerable: true,
  get: function () {
    return SettingsEngine_1.SESSION_SETTINGS_MODE;
  }
});
Object.defineProperty(exports, "SettingsEngine", {
  enumerable: true,
  get: function () {
    return SettingsEngine_1.SettingsEngine;
  }
});
const ShapeDiverBackendErrors_1 = _ShapeDiverBackendErrors;
Object.defineProperty(exports, "ShapeDiverGeometryBackendError", {
  enumerable: true,
  get: function () {
    return ShapeDiverBackendErrors_1.ShapeDiverGeometryBackendError;
  }
});
Object.defineProperty(exports, "ShapeDiverGeometryBackendRequestError", {
  enumerable: true,
  get: function () {
    return ShapeDiverBackendErrors_1.ShapeDiverGeometryBackendRequestError;
  }
});
Object.defineProperty(exports, "ShapeDiverGeometryBackendResponseError", {
  enumerable: true,
  get: function () {
    return ShapeDiverBackendErrors_1.ShapeDiverGeometryBackendResponseError;
  }
});
const sdk_geometry_api_sdk_v2_1 = _sdk;
Object.defineProperty(exports, "ShapeDiverGeometryBackendResponseErrorType", {
  enumerable: true,
  get: function () {
    return sdk_geometry_api_sdk_v2_1.ShapeDiverResponseErrorType;
  }
});
const ShapeDiverViewerErrors_1 = _ShapeDiverViewerErrors;
Object.defineProperty(exports, "ShapeDiverViewerArError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerArError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerCameraError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerCameraError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerDataProcessingError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerDataProcessingError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerDrawingToolsError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerDrawingToolsError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerEnvironmentMapError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerEnvironmentMapError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerInteractionError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerInteractionError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerLightError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerLightError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerSessionError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerSessionError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerSettingsError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerSettingsError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerUnknownError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerUnknownError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerValidationError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerValidationError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerViewportError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerViewportError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerWebGLError", {
  enumerable: true,
  get: function () {
    return ShapeDiverViewerErrors_1.ShapeDiverViewerWebGLError;
  }
});
const ShapeDiverError_1 = _ShapeDiverError;
Object.defineProperty(exports, "ShapeDiverViewerError", {
  enumerable: true,
  get: function () {
    return ShapeDiverError_1.ShapeDiverViewerError;
  }
});
Object.defineProperty(exports, "ShapeDiverViewerErrorType", {
  enumerable: true,
  get: function () {
    return ShapeDiverError_1.ShapeDiverViewerErrorType;
  }
});
const StateEngine_1 = _StateEngine;
Object.defineProperty(exports, "StateEngine", {
  enumerable: true,
  get: function () {
    return StateEngine_1.StateEngine;
  }
});
const StatePromise_1 = _StatePromise;
Object.defineProperty(exports, "StatePromise", {
  enumerable: true,
  get: function () {
    return StatePromise_1.StatePromise;
  }
});
const SystemInfo_1 = _SystemInfo;
Object.defineProperty(exports, "SystemInfo", {
  enumerable: true,
  get: function () {
    return SystemInfo_1.SystemInfo;
  }
});
const TypeChecker_1 = _TypeChecker;
Object.defineProperty(exports, "TypeChecker", {
  enumerable: true,
  get: function () {
    return TypeChecker_1.TypeChecker;
  }
});
const UuidGenerator_1 = _UuidGenerator;
Object.defineProperty(exports, "UuidGenerator", {
  enumerable: true,
  get: function () {
    return UuidGenerator_1.UuidGenerator;
  }
});
const base64_1 = _base;
Object.defineProperty(exports, "atobCustom", {
  enumerable: true,
  get: function () {
    return base64_1.atobCustom;
  }
});
Object.defineProperty(exports, "btoaCustom", {
  enumerable: true,
  get: function () {
    return base64_1.btoaCustom;
  }
});
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  isViewerWebGLError = exports.isViewerWebGLError,
  isViewerEnvironmentMapError = exports.isViewerEnvironmentMapError,
  isViewerDataProcessingError = exports.isViewerDataProcessingError,
  isViewerUnknownError = exports.isViewerUnknownError,
  isViewerError = exports.isViewerError,
  ShapeDiverGeometryBackendResponseErrorType = exports.ShapeDiverGeometryBackendResponseErrorType,
  ShapeDiverGeometryBackendResponseError = exports.ShapeDiverGeometryBackendResponseError,
  ShapeDiverGeometryBackendRequestError = exports.ShapeDiverGeometryBackendRequestError,
  ShapeDiverGeometryBackendError = exports.ShapeDiverGeometryBackendError,
  ShapeDiverViewerDrawingToolsError = exports.ShapeDiverViewerDrawingToolsError,
  ShapeDiverViewerInteractionError = exports.ShapeDiverViewerInteractionError,
  ShapeDiverViewerValidationError = exports.ShapeDiverViewerValidationError,
  ShapeDiverViewerCameraError = exports.ShapeDiverViewerCameraError,
  ShapeDiverViewerLightError = exports.ShapeDiverViewerLightError,
  ShapeDiverViewerArError = exports.ShapeDiverViewerArError,
  ShapeDiverViewerUnknownError = exports.ShapeDiverViewerUnknownError,
  ShapeDiverViewerViewportError = exports.ShapeDiverViewerViewportError,
  ShapeDiverViewerSessionError = exports.ShapeDiverViewerSessionError,
  ShapeDiverViewerSettingsError = exports.ShapeDiverViewerSettingsError,
  ShapeDiverViewerWebGLError = exports.ShapeDiverViewerWebGLError,
  ShapeDiverViewerEnvironmentMapError = exports.ShapeDiverViewerEnvironmentMapError,
  ShapeDiverViewerDataProcessingError = exports.ShapeDiverViewerDataProcessingError,
  ShapeDiverViewerError = exports.ShapeDiverViewerError,
  ShapeDiverViewerErrorType = exports.ShapeDiverViewerErrorType,
  LOGGING_LEVEL = exports.LOGGING_LEVEL,
  Logger = exports.Logger,
  InputValidator = exports.InputValidator,
  TypeChecker = exports.TypeChecker,
  Converter = exports.Converter,
  UuidGenerator = exports.UuidGenerator,
  HttpClient = exports.HttpClient,
  DomEventEngine = exports.DomEventEngine,
  SystemInfo = exports.SystemInfo,
  StatePromise = exports.StatePromise,
  StateEngine = exports.StateEngine,
  SESSION_SETTINGS_MODE = exports.SESSION_SETTINGS_MODE,
  SettingsEngine = exports.SettingsEngine,
  EVENTTYPE_TASK = exports.EVENTTYPE_TASK,
  EVENTTYPE_DRAWING_TOOLS = exports.EVENTTYPE_DRAWING_TOOLS,
  EVENTTYPE_GUMBALL = exports.EVENTTYPE_GUMBALL,
  EVENTTYPE_INTERACTION = exports.EVENTTYPE_INTERACTION,
  EVENTTYPE_VIEWPORT = exports.EVENTTYPE_VIEWPORT,
  EVENTTYPE_SESSION = exports.EVENTTYPE_SESSION,
  EVENTTYPE_SCENE = exports.EVENTTYPE_SCENE,
  EVENTTYPE_RENDERING = exports.EVENTTYPE_RENDERING,
  EVENTTYPE_PARAMETER = exports.EVENTTYPE_PARAMETER,
  EVENTTYPE_OUTPUT = exports.EVENTTYPE_OUTPUT,
  EVENTTYPE_CAMERA = exports.EVENTTYPE_CAMERA,
  EVENTTYPE = exports.EVENTTYPE,
  EventEngine = exports.EventEngine,
  btoaCustom = exports.btoaCustom,
  atobCustom = exports.atobCustom,
  PerformanceEvaluator = exports.PerformanceEvaluator,
  isViewerGeometryBackendResponseError = exports.isViewerGeometryBackendResponseError,
  isViewerGeometryBackendRequestError = exports.isViewerGeometryBackendRequestError,
  isViewerGeometryBackendGenericError = exports.isViewerGeometryBackendGenericError,
  isViewerGeometryBackendError = exports.isViewerGeometryBackendError,
  isViewerDrawingToolsError = exports.isViewerDrawingToolsError,
  isViewerInteractionError = exports.isViewerInteractionError,
  isViewerValidationError = exports.isViewerValidationError,
  isARError = exports.isARError,
  isViewerCameraError = exports.isViewerCameraError,
  isViewerLightError = exports.isViewerLightError,
  isViewerViewportError = exports.isViewerViewportError,
  isViewerSessionError = exports.isViewerSessionError,
  isViewerSettingsError = exports.isViewerSettingsError;